import React, { useState } from 'react';
import { db } from '../firebase';
import { doc, updateDoc, deleteField } from 'firebase/firestore';

function LinksPorCategoria({ modo, categorias }) {
  const [mensagem, setMensagem] = useState('');

  async function atualizarLink(catId, novoLink) {
    try {
      const ref = doc(db, `modos/${modo}/categorias/${catId}`);
      await updateDoc(ref, { linkCategoria: novoLink });
      setMensagem(`Link de ${catId} atualizado com sucesso.`);
    } catch (erro) {
      console.error('Erro ao atualizar link:', erro);
      setMensagem(`Erro ao atualizar link de ${catId}.`);
    }
    setTimeout(() => setMensagem(''), 4000);
  }

  async function removerLink(catId) {
    try {
      const ref = doc(db, `modos/${modo}/categorias/${catId}`);
      await updateDoc(ref, { linkCategoria: deleteField() });
      setMensagem(`Link de ${catId} removido.`);
    } catch (erro) {
      console.error('Erro ao remover link:', erro);
      setMensagem(`Erro ao remover link de ${catId}.`);
    }
    setTimeout(() => setMensagem(''), 4000);
  }

  return (
    <div className="links-categorias-container">
      <h2>Links por Categoria – {modo}</h2>

      {mensagem && <p className="mensagem">{mensagem}</p>}

      {categorias.map((cat) => (
        <div key={cat.id} className="link-item">
          <strong>{cat.id}</strong>
          <input
            type="text"
            defaultValue={cat.linkCategoria || ''}
            onBlur={(e) => {
              const valor = e.target.value.trim();
              const atual = cat.linkCategoria || '';
              if (valor === atual) return;               // nada mudou
              if (valor === '') removerLink(cat.id);      // apagar campo
              else atualizarLink(cat.id, valor);          // guardar novo link
            }}
          />
        </div>
      ))}
    </div>
  );
}

export default LinksPorCategoria;
